import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Pep } from "../../models/trust/empleado/Pep";
import { PepTFService } from "../../service/trust/empleado/PepTFService";

export const PersonaExpuesta = ({ toast, id, permss, soloLectura, onPepChange }) => {

    const omodel = new Pep();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const menuRef = useRef(null);

    const pepSrv = new PepTFService();
    const tablaPep = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inText } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaPep.lazyParams, id]);

    const loadLazyData = () => {
        tablaPep.setLoading(true);
        const _params = { ...tablaPep.lazyParams, idp: id };
        pepSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaPep.setTotalRecords(res.data.total);
            tablaPep.setData(res.data.registros);
            // Le avisamos al padre el total de registros
            if (onPepChange) {
                onPepChange(res.data.total);
            }
        }).finally(() => tablaPep.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;

        const request = getValues('id') == null
            ? pepSrv.nuevo(data)
            : pepSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        pepSrv.consultar(idReg).then(res => {
            reset(generic.renewValues(res.data.pep, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este registro PEP?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                pepSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_pep" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Personas Expuestas Políticamente
            </span>
        </div>
    );

    return (
        <div className="componente-persona-expuesta">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_pep" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaPep} datos={tablaPep.data} totalRegistros={tablaPep.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nuevo Registro PEP" : "Editar Registro PEP"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '580px' }}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-id-card text-primary"></i>
                                    PERSONA EXPUESTA POLÍTICAMENTE
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inText('nombre_completo', { icon: 'pi pi-user' }, 12)}
                        {inText('entidad_publica', { icon: 'pi pi-building' }, 6)}
                        {inText('cargo_publico', { icon: 'pi pi-briefcase' }, 6)}
                        {inText('parentesco', { icon: 'pi pi-users' }, 12)}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col">
                                    <Button label="Cerrar" style={{ maxWidth: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
